import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { fibonacci } from '../layout';

const Inner = styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  position: absolute;
  display: flex;
`;

const div = ({ className, children, ...rest }) => {
  return (
    <div className={className} {...rest}>
      <Inner>{children}</Inner>{' '}
    </div>
  );
};

export const Circle = styled(div)<any>`
  border-radius: 50%;
  /* padding-top: 100%; */
  width: ${({ theme, size }) => theme.baseSpace * fibonacci(size)}px;
  height: ${({ theme, size }) => theme.baseSpace * fibonacci(size)}px;
  background-color: ${({ color }) => color};
  overflow: hidden;
  position: relative;
`;
